/**
 * Ryan O'Dowd
 * 2022-12-29
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const AlertMessages = (props: AlertMessagesProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      {!!props.errorMessage &&
        <Text style={styles.errorText}>
          {props.errorMessage}
        </Text>
      }
      {!!props.successMessage &&
        <Text style={styles.successText}>
          {props.successMessage}
        </Text>
      }
    </View>
  );
};

class AlertMessagesProps {
  errorMessage?: string;
  successMessage?: string;
};

export default AlertMessages;
